import { SvgIcon } from "@mui/material";
import StarsIcon from '@mui/icons-material/Stars';

const ExclusiveStarIcon = (props: any) => (
    <SvgIcon {...props}>
        <circle cx="12" cy="12" r="10" fill="currentColor" />
        <StarsIcon className='text-strike' />
    </SvgIcon>
);

export default ExclusiveStarIcon;